<app-alert-box-component 
  (OnButtonClick)="onAlertButtonClick($event)"
  (OnAlertClose)="closeAlert($event)" 
  (OnAlertVisibility)="alertVisibility($event)"
  [bShowSecondButton]="bShowSecondAlertButton"
  [alertHeaderText]="alertHeaderText" 
  [alertBodyText]="alertBodyText" 
  [closeButtonText]="alertCloseButtonText"
  [secondButtonText]="alertSecondButtonText"
  [data]="alertBoxData"
  [bAlert]="bAlert"></app-alert-box-component>

<div class="bg-light dark:bg-transparent min-vh-100 d-flex flex-row align-items-center">
  <c-container breakpoint="md">
    <c-row class="justify-content-center">
      <c-col lg="10" xl="8">
        <c-card-group>
          <c-card class="p-4">
            <c-card-body>
              <form 
                [formGroup]="forgotPasswordForm"
                cForm cRow (ngSubmit)="changePassword()" 
                [gutter]="3"
                [validated]="customStylesValidated"
                cForm
                class="row g-3 needs-validation">
                <h1>Change Password</h1>
                <p class="text-medium-emphasis">Please change your password now</p>
                <c-input-group class="mb-3 has-validation" >
                  <span cInputGroupText>
                    <svg cIcon name="cilLockLocked"></svg>
                  </span>
                  <input formControlName="password_1" name="password_1" required type="password" cFormControl placeholder="New Password" />
                  <c-form-feedback [valid]="true">Looks good!</c-form-feedback>
                  <c-form-feedback [valid]="false">Please enter a password</c-form-feedback>
                </c-input-group>
                <c-input-group class="mb-4">
                  <span cInputGroupText>
                    <svg cIcon name="cilLockLocked"></svg>
                  </span>
                  <input formControlName="password_2" name="password_2" required type="password" cFormControl placeholder="Repeat New Password" />
                  <c-form-feedback [valid]="true">Looks good!</c-form-feedback>
                  <c-form-feedback [valid]="false">Please enter a password</c-form-feedback>
                </c-input-group>
                <c-row>
                  <c-col xs="6">
                    <button cButton class="px-4" color="primary" type="submit">
                      <c-spinner *ngIf="bLoading" aria-hidden="true" size="sm"></c-spinner>
                      Change
                    </button>
                  </c-col>
                </c-row>
              </form>
            </c-card-body>
          </c-card>
          <c-card [ngStyle]="{'minWidth.%': 44}" class="loginbgimg text-white bg-primary py-5">
            <c-card-body class="text-center">
            </c-card-body>
          </c-card>
        </c-card-group>
      </c-col>
    </c-row>
  </c-container>
</div>
